export default __webpack_public_path__ + "static/media/checked.5f68f34a.svg";